<ng-container *ngIf="showTableauView">
  <ngx-tableau [tableauVizUrl]="tableauViewUrl"></ngx-tableau>
</ng-container>



// WEBPACK FOOTER //
// ./src/app/views/campaign-2.0/campaign-monitor/campaign-monitor.component.html